const PALETTE = ["#A4247F", "#EC7F13", "#2563EB", "#0D9488", "#7C3AED", "#DC2626", "#0891B2", "#CA8A04"];

export const initials = (name = "") =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();

export const colorFor = (text = "") => PALETTE[[...text].reduce((acc, c) => acc + c.charCodeAt(0), 0) % PALETTE.length];

export const formatDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "short", year: "numeric" }) : "—";

export const formatNumber = (n) => (n ?? 0).toLocaleString("fr-FR");

export const plural = (n, one, many) => `${formatNumber(n)} ${n > 1 ? many : one}`;

export const slugify = (text = "") =>
  text
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

export const chipStyle = (color) =>
  color ? { backgroundColor: `${color}14`, color, borderColor: `${color}38` } : undefined;
